<div [class.oculto]="modalrecogidaSrv.ocultarModal"
     class="fondo-modal-imagen ">

  <div class="modal fade show"
       id="exampleModal"
       tabindex="-1"
       role="dialog"
       aria-labelledby="exampleModalLabel1"
       style="display: block;"
       (click)="cerrarModalClickOutside($event)">
    <div class="modal-dialog"
         role="document">

      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title"
              id="exampleModalLabel1">
            <i class="fa-solid fa-cart-flatbed"></i> Modificar cantidad recogida
          </h4>
          <button type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close">
            <span (click)="cerrarModal()"
                  aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">

          <div class="row">
            <div class="col-sm-12">
              <div class="card card-body">
                <h4 title={{funcLib.CodUbiDecript(modalrecogidaSrv.preparacion?.ubicacion)}}>
                  Ubicación origen: {{modalrecogidaSrv.preparacion?.ubicacion | mask: '00.00.00.00.00.00'}}
                </h4>
                <h4> Ubicación actual: {{modalrecogidaSrv.preparacion?.uic}} </h4>
                <h6>
                  EAN: <span class="card-subtitle"> {{modalrecogidaSrv.preparacion?.ean}}</span>
                  SKU: <span class="card-subtitle"> {{modalrecogidaSrv.preparacion?.sku}}</span>
                  <span *ngIf="modalrecogidaSrv.preparacion?.swDefectuoso==='2'"
                        class="badge badge-pill badge-danger ml-2">DEFECTUOSO</span>
                </h6>
                <h6 *ngIf="modalrecogidaSrv.preparacion?.lote"> Lote: <span class="card-subtitle text-info"> {{modalrecogidaSrv.preparacion?.lote}}</span></h6>
                <h6> <span class="card-subtitle"> {{modalrecogidaSrv.preparacion?.descripcion}}</span></h6>

                <div class="table-responsive mt-3">
                  <table class="table table-sm table-bordered">
                    <thead class="bg-light">
                      <tr>
                        <th>Concepto</th>
                        <th class="text-right">Cantidad</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Stock en esta ubicación</td>
                        <td class="text-right"><strong>{{modalrecogidaSrv.preparacion?.stockUbi | number: '0.0-0':'es'}}</strong></td>
                      </tr>
                      <tr>
                        <td>Cantidad reservada</td>
                        <td class="text-right"><strong>{{modalrecogidaSrv.preparacion?.cant_reserva | number: '0.0-0':'es'}}</strong></td>
                      </tr>
                      <tr>
                        <td>Cantidad recogida</td>
                        <td class="text-right text-info"><strong>{{modalrecogidaSrv.preparacion?.cant_recogida | number: '0.0-0':'es'}}</strong></td>
                      </tr>
                      <tr>
                        <td>Cantidad repartida</td>
                        <td class="text-right text-success"><strong>{{modalrecogidaSrv.preparacion?.cant_repartida | number: '0.0-0':'es'}}</strong></td>
                      </tr>
                      <tr>
                        <td>Reserva inicial</td>
                        <td class="text-right"><strong>{{modalrecogidaSrv.preparacion?.cant_inicial | number: '0.0-0':'es'}}</strong></td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <form [formGroup]="recogidaForm"
                      (ngSubmit)="enviar()"
                      class="form-horizontal mt-2">


                  <!-- cantidad -->
                  <div class="col-12">
                    <div class="form-group"
                         [ngClass]="{ 'has-danger': enviado && f['cantidad'].errors }">
                      <label class="form-control-label">Cantidad actual en esta recogida:</label>
                      <input type="number"
                             formControlName="cantidad"
                             class="form-control"
                             [ngClass]="{ 'form-control-danger': enviado && f['cantidad'].errors }">

                      <div *ngIf="enviado && f['cantidad'].errors"
                           class="form-control-feedback">
                        <div *ngIf="f['cantidad'].errors['min']">Mínimo 0 unidades</div>
                        <div *ngIf="f['cantidad'].errors['max']">Máximo {{modalrecogidaSrv.preparacion?.cant_recogida}} unidades</div>
                        <div *ngIf="recogidaForm.get('cantidad')?.errors?.['apiError']">{{recogidaForm.get('cantidad')?.errors?.['apiError'] }}</div>
                      </div>
                    </div>
                  </div>


                  <!-- descripcion -->
                  <div class="col-12">
                    <div class="form-group"
                         [ngClass]="{ 'has-danger': enviado && f['descripcion'].errors }">
                      <label class="form-control-label">Descripción:</label>
                      <input type="text"
                             formControlName="descripcion"
                             class="form-control"
                             [ngClass]="{ 'form-control-danger': enviado && f['descripcion'].errors }">

                      <div *ngIf="enviado && f['descripcion'].errors"
                           class="form-control-feedback">
                        <div *ngIf="f['descripcion'].errors['required']">La descripción es necesaria para incluirla en transacciones</div>
                        <div *ngIf="f['descripcion'].errors['minlength']">Debe contener un mínimo de 4 caracteres</div>
                        <div *ngIf="f['descripcion'].errors['maxlength']">La descripción puede exceder de 150 caracteres</div>
                        <div *ngIf="recogidaForm.get('descripcion')?.errors?.['apiError']">
                          {{recogidaForm.get('descripcion')?.errors?.['apiError'] }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex">
                    <button (click)="cerrarModal()"
                            class="btn waves-effect waves-light btn-rounded btn-secondary"
                            data-dismiss="modal">Cancelar</button>

                    <button [disabled]="loading"
                            type="submit"
                            class="ml-auto btn waves-effect waves-light btn-rounded btn-success"> <i class="fa fa-spinner fa-spin"
                         *ngIf="loading"></i> Enviar</button>
                  </div>

                </form>
              </div>
            </div>
          </div>



        </div>
      </div>
    </div>
  </div>


</div>